<!--The content below is only a placeholder and can be replaced.-->
<div>
    <div class="off-stage">
        <off-canvas></off-canvas>
    </div>

    <div class="main-stage">
        <div class="outlet-shell">
            <app-shopping-stepper></app-shopping-stepper>
            <router-outlet></router-outlet>
        </div>
        <app-sleek-note></app-sleek-note>
    </div>

    <app-order-expired-modal #orderExpiredModal></app-order-expired-modal>
    <app-login-needed-modal #loginNeededModal [expired]="isExpired"></app-login-needed-modal>
    <app-request-signout-modal #requestSignoutModal></app-request-signout-modal>
</div>
